/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {
    // Set mails flag unread to true
  createStudentNotice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/student-notice/create", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('CREATE_STUDENTNOTICE', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateStudentNotice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/student-notice/update", payload)
      .then((response) => {
        if(response.data.result == 'success'){
          commit('UPDATE_STUDENTNOTICE', response.data.data)
          resolve(response)
        }
        reject(response)
      }).catch((error) => { reject(error) })
    })
  },
  deleteStudentNotice({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/workspace/student-notice/delete/"+ payload)
      .then((response) => {
        if(response.data.result == 'success'){
          commit("DELETE_STUDENTNOTICE", payload)
          resolve(response)
        }
        reject(response)
      }).catch((error) => { reject(error) })
    })
  },
  getStudentNotice({ commit }, payload) {
    // var projectInfo = {"project_id": payload.project_Id}
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/student-notice/"+payload)
      .then((response) => {
        if(response.data.result == 'success'){
          commit("SET_STUDENTNOTICE_LIST", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => { reject(error) })
    })
  },
  setStudentNoticeSearchQuery({ commit }, query){
    commit("SET_STUDENTNOTICE_SEARCH_QUERY", query)
  },
  addStudentNoticeComment({commit}, payload){
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/student-notice/comment/create", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('CREATE_STUDENTNOTICE_COMMENT', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getStudentNoticeComment({ commit }, payload) {
    // var projectInfo = {"project_id": payload.project_Id}
    return new Promise((resolve, reject) => {
      axios.get("/api/workspace/student-notice/comment/"+payload)
      .then((response) => {
        if(response.data.result == 'success'){
          commit("SET_STUDENTNOTICE_COMMENT_LIST", response.data.data_list)
          resolve(response)
        }
        reject(response)
      }).catch((error) => { reject(error) })
    })
  },
  deleteStudentNoticeComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/workspace/student-notice/comment/delete/"+ payload)
      .then((response) => {
        if(response.data.result == 'success'){
          commit("DELETE_STUDENTNOTICE_COMMENT", payload)
          resolve(response)
        }
        reject(response)
      }).catch((error) => { reject(error) })
    })
  },
  updateStudentNoticeComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/workspace/student-notice/comment/update", payload)
      .then((response) => {
        if(response.data.result == 'success'){
          commit('UPDATE_STUDENTNOTICE_COMMENT', response.data.data)
          resolve(response)
        }
        reject(response)
      }).catch((error) => { reject(error) })
    })
  },
}
